var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-sm",class:{
  'table-striped': _vm.type === 'striped'
}},[(_vm.$slots.header)?[_c('thead',[_vm._t("header")],2)]:_vm._e(),(_vm.$slots.body)?[_c('tbody',[_vm._t("body")],2)]:_vm._e(),(_vm.$slots.footer)?[_c('tfoot',[_vm._t("footer")],2)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }